import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';

import { CustomerPortalAssetName } from '@customer-portal/common/ui-asset-not-found';
import { CustomerPortalDocumentDetailsActions } from '@customer-portal/documents/data-access-details';

const DOCUMENT_TYPE_MAP: Record<string, CustomerPortalAssetName> = {
  order: CustomerPortalAssetName.Order,
  quote: CustomerPortalAssetName.Quote,
  invoice: CustomerPortalAssetName.Invoice,
};

export const resolveDocumentDetails: ResolveFn<void> = (route) => {
  const store = inject(Store);

  const documentType = route.data['visitedPage'];
  const projectId = route.parent?.paramMap.get('projectId');
  const documentId = route.paramMap.get('documentId');

  if (!documentType || !documentId) return;

  const assetName = DOCUMENT_TYPE_MAP[documentType];

  store.dispatch(
    new CustomerPortalDocumentDetailsActions.Get(
      documentId,
      assetName,
      projectId!
    )
  );

  return;
};
